<div [ngClass]="customCssClass" class="treatment-details-container">
  <div class="modal-top">
    <h2>
      {{ content.name }}
    </h2>
    <div class="close-btn">
      <app-ui-icon (click)="closeDialog()" color="var(--blue-3)" name="close" size="md"></app-ui-icon>
    </div>
  </div>

  <div class="scrollable-content">
    <div [innerHTML]="content.seoInformation"></div>
    <app-ui-button
      (onClick)="closeDialog()"
      [color]="'ghost'"
      [compressed]="false"
      [expanded]="'block'"
      [size]="'lg'"
    >
      Stäng
    </app-ui-button>
  </div>

  <div *ngIf="content.showBookingButton" class="modal-actions">
    <app-ui-button
      (onClick)="book()"
      [color]="'primary'"
      [compressed]="false"
      [expanded]="'block'"
      [size]="'lg'"
      class="btn-block varden-btn__narrow"
    >
      Boka
    </app-ui-button>
  </div>
</div>
